import { useAuth0 } from '@auth0/auth0-react';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

import { clearUserSession } from '../auth/sessionCleanup';
import { translate } from '../common/helpers/translate.helper';
import { useDocumentTitle } from '../common/hooks/useDocumentTitle';
import { LoadingWithWobble } from '../LoadingWithWobble';

const LoginSearchSchema = z.object({
    email: z.string().email().optional().catch(undefined),
    redirect: z.string().optional().catch(undefined),
});

const Login = () => {
    const { loginWithRedirect } = useAuth0();
    const search = useSearch({ from: '/login' });

    useDocumentTitle(translate('login.pageTitle'));

    useEffect(() => {
        const returnTo = search.redirect;

        loginWithRedirect({
            appState: {
                returnTo,
            },
            authorizationParams: {
                login_hint: search.email,
            },
        });
    }, [loginWithRedirect, search.redirect, search.email]);

    return <LoadingWithWobble />;
};

export const Route = createFileRoute('/login')({
    validateSearch: (search: Record<string, unknown>) => LoginSearchSchema.parse(search),
    onEnter: () => {
        window.Productlane?.close();
        window.fcWidget?.close();
        window.fcWidget?.user?.clear();

        clearUserSession();
    },
    component: Login,
});
